import * as types from "../constants/ActionTypes";
var initialState = [];

var listPayPalAccounts = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_LIST_PAYPAL_ACCOUNTS:
      state = action.listPayPalAccounts;
      return [...state];
    default:
      return [...state];
  }
};
export default listPayPalAccounts;
